import gql from 'graphql-tag';

export const foldersQuery = gql`
  query Folders($parentFolderId: String, $type: FolderType = archive) {
    folders(parentFolderId: $parentFolderId, type: $type) {
      type
      name
      id
      parentHashId
      documents {
        document {
          id
        }
      }
    }
  }
`;

export const folderBreadcrumbQuery = gql`
  query FolderBreadcrumb($parentFolderId: String, $type: FolderType = archive) {
    folderBreadcrumb(parentFolderId: $parentFolderId, type: $type) {
      name
      id
    }
  }
`;

export const loadFolderTreeQuery = gql`
  query FolderTree($type: FolderType = archive) {
    folderTree(type: $type)
  }
`;
